module.exports = "<!-- * TEXT-SECTION * -->\n<router-outlet></router-outlet>\n"